<template>
    <FormSection title="Comments" :full-height="false" :application-id="referral.application">
        <template #content>
            <section class="d-flex flex-column px-3 py-2">
                <div class="form-group col-12">
                    <CommentInput
                        input-name="referral-comments"
                        :result="referral.comments"
                        placeholder="Enter Comments"
                        :class-list="commentInputClass"
                        :application="referral.application"
                        :max-length="5000"
                        :show-template-typeahead="false"
                        :show-template-dropdown="true"
                        v-on:resultUpdatedAppended="resultUpdatedAppended"
                        v-on:resultUpdated="resultUpdated"
                    />
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import CommentInput from "../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";

export default defineComponent({
    components: {
        FormSection,
        CommentInput
    },

    props: {
        referral: { type: Object, default: null }
    },
    data() {
        return {
            commentInputClass: { input: "w-35" } as { input: string; textarea?: string }
        };
    },
    methods: {
        resultUpdatedAppended(value: string) {
            this.referral.comments += value;
        },
        resultUpdated(value: string) {
            this.referral.comments = value;
        }
    }
});
</script>
